import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import {
  type V1GetJobPostingCardsResponse,
  type ComponentServiceGetJobPostingCardsRequest
} from 'mnvm-mypage-app-ts-if'
import { getJobPostingCards } from '@/api/component-service-api'

export const useJobPostingCards = (
  request: ComponentServiceGetJobPostingCardsRequest,
  currentPage?: number
): UseQueryResult<V1GetJobPostingCardsResponse, unknown> => {
  return useQuery({
    queryKey: ['getJobPostingCards', currentPage],
    queryFn: async () => await getJobPostingCards(request),
    cacheTime: 0
  })
}
